import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
// import '../styles/HomePage.css';
import Header from "./common/Header";
import Sidebar from "../common/Sidebar";
import MobileTopbar from "../common/MobileTopbar";
import MobileSidebarDrawer from "../common/MobileSidebarDrawer";
import { UserContext } from "../contexts/UserContext";
import { SyllabusContext } from "../contexts/SyllabusContext";
const HomePage = () => {
  const navigate = useNavigate();
  const syllabusContext = useContext(SyllabusContext);
  const { fetchSyllabus } = syllabusContext || {};
  const userContext = useContext(UserContext) || {};
  const { fetchUserProfile } = userContext;
  const location = useLocation();
  const isTutorRoute =
    location.pathname.startsWith("/tutor") ||
    location.pathname.startsWith("/practice/tutor");
  const isProfileRoute = location.pathname.startsWith("/profile-update");
  const isGoalQuestionsRoute = location.pathname.includes("goalquestions");
  const disableMobileNav = isTutorRoute || isProfileRoute;
  const isNormalChatRoute =
    location.pathname === "/tutor" ||
    location.pathname === "/tutor/" ||
    location.pathname === "/practice/tutor" ||
    location.pathname === "/practice/tutor/";
  const shouldShowHeader =
    !location.pathname.startsWith("/assessment") &&
    !location.pathname.startsWith("/practice") &&
    !isProfileRoute;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (typeof fetchUserProfile === "function") {
      fetchUserProfile();
    }
    // We intentionally fetch once when HomePage is in view.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (disableMobileNav || isGoalQuestionsRoute) {
      setIsMobileMenuOpen(false);
    }
  }, [disableMobileNav, isGoalQuestionsRoute]);

  useEffect(() => {
    if (typeof fetchSyllabus === "function") {
      fetchSyllabus();
    }
    // We intentionally trigger this only once on mount to ensure syllabus data loads when the layout renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Mobile Drawer */}
      {!disableMobileNav && !isGoalQuestionsRoute && (
        <MobileSidebarDrawer
          open={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      )}

      {shouldShowHeader && (
        <div className="fixed top-0 left-0 right-0 z-20 h-1/10 pointer-events-none">
          <Header />
        </div>
      )}

      <div className="h-[100dvh] flex overflow-hidden">
        {/* Sidebar shown only on md+ via component class */}
        {!isGoalQuestionsRoute && <Sidebar />}

        <div className="-4 flex-1 flex flex-col overflow-hidden ">
          {/* Mobile Topbar with adaptive controls */}
          <MobileTopbar
            onMenuClick={() => setIsMobileMenuOpen(true)}
            showMenuButton={!disableMobileNav && !isGoalQuestionsRoute}
            showProfileButton={disableMobileNav}
            showEditButton={isNormalChatRoute}
            onProfileClick={() => navigate("/profile-update")}
            onHomeClick={() => navigate("/tutor")}
            onHeadingClick={() => navigate("/tutor")}
          />

          <div className="px-4 h-full overflow-y-scroll">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
